import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rating-exercisePrevention",
  "use": "rating-exercisePrevention-usage",
  "viewBox": "0 0 25 21",
  "content": "<symbol viewBox=\"0 0 25 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rating-exercisePrevention\">\n  <path d=\"m12.5 4.61 1.24-1.41a5.4 5.4 0 0 1 6.8-1.61 5.52 5.52 0 0 1 2.85 4.87v0a5.57 5.57 0 0 1-1.97 4.26L13.1 18.9a.84.84 0 0 1-1.21 0l-8.3-8.17A5.57 5.57 0 0 1 1.6 6.46v0A5.52 5.52 0 0 1 4.46 1.6a5.4 5.4 0 0 1 6.8 1.6L12.5 4.6Z\" stroke=\"#F36A20\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol